import { useCallback, useState } from 'react';
import { IProductDto } from '@common/features/submission/types';

const SUBMISSION_WARNING =
  'You cannot delete the last product in a submission. If you would like to remove the last product association, please cancel the submission and retire the document.';
const TASK_WARNING = 'Unable to remove product, document must have at least one product';

export const useLastProductWarningModal = (
  submissionProducts?: IProductDto[],
  taskProducts?: IProductDto[],
) => {
  const [warningMessage, setWarningMessage] = useState<string | null>(null);

  const checkLastProductWarning = useCallback((): boolean => {
    if (submissionProducts?.length === 1) {
      setWarningMessage(SUBMISSION_WARNING);
      return true;
    }
    if (taskProducts?.length === 1) {
      setWarningMessage(TASK_WARNING);
      return true;
    }
    return false;
  }, [submissionProducts, taskProducts]);

  const closeLastProductWarning = useCallback(() => setWarningMessage(null), []);

  return {
    isLastProductWarningOpen: warningMessage !== null,
    lastProductWarningMessage: warningMessage,
    checkLastProductWarning,
    closeLastProductWarning,
  };
};
